export default __webpack_public_path__ + "static/media/br3.fe493f75.webp";